module.exports = __webpack_public_path__ + "static/media/headerLogo.ee63a21c.png";